var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gallery",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.917,48.333h14.5c12.083,0,16.917-4.833,16.917-16.917v-14.5C48.333,4.833,43.5,0,31.417,0h-14.5C4.833,0,0,4.833,0,16.917v14.5C0,43.5,4.833,48.333,16.917,48.333Z",
    transform: "translate(4.833 4.833)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M9.667,4.833A4.833,4.833,0,1,1,4.833,0,4.833,4.833,0,0,1,9.667,4.833Z",
    transform: "translate(16.917 14.5)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,16.8l11.914-8a5.445,5.445,0,0,1,6.38.338l.8.7a5.388,5.388,0,0,0,6.815,0L35.96,1.214a5.388,5.388,0,0,1,6.815,0L46.714,4.6",
    transform: "translate(6.453 28.994)",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H58V58H0Z",
    fill: "none",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhot);
export default __webpack_public_path__ + "static/media/phot.7077bacbd86e46e713fe66abd42efdff.svg";
export { ForwardRef as ReactComponent };